export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.22-1237.10",
  commitId: "05688766e7a9c69c0cb12e23507d90dd5ba14c3f",
  commitTime: "2026-04-22T12:37:10.000Z",
});
